import React, { useRef } from 'react';
import classnames from 'classnames';
import { useOnClickOutside } from '../../hooks';
import { getProductInfo } from '../../utils';
import './UserMenu.scss';
import { Icon } from '../Icon';
const UserMenu = ({ showMenu, toggleMenu, setShowMenu, user, productPrefix, children, }) => {
    const ref = useRef(null);
    useOnClickOutside(ref, () => setShowMenu(false));
    return (React.createElement("div", { className: "usermenu-wrapper", ref: ref },
        React.createElement("div", { className: classnames('menu', { hide: !showMenu }) },
            React.createElement("div", { className: "menu-container" },
                React.createElement("div", { className: "area user-name" }, user),
                React.createElement("div", { className: "menu-list" }, children &&
                    React.Children.map(children, (child) => (React.createElement("div", { className: "menu-list-item", key: `menu-item-${child === null || child === void 0 ? void 0 : child.toString()}` }, child)))),
                React.createElement("div", { className: "area product-version" }, getProductInfo(productPrefix !== null && productPrefix !== void 0 ? productPrefix : ''))),
            React.createElement("div", { className: "arrow-down" })),
        React.createElement("button", { type: "button", className: "user", "aria-label": "user-menu", onClick: toggleMenu },
            React.createElement(Icon, { source: "UserProfile" }))));
};
export default UserMenu;
//# sourceMappingURL=UserMenu.js.map